<template>
  <div v-if="edit">
    <div v-if="btnPermissionsStr.includes('view:ssgprojectlist')">
    <div class="headerBox">
      <div class="header">
        <div class="logo">
          <img src="../../assets/img/logossg.png" />
        </div>
        <div>
          <el-dropdown @command="addCommand">
            <div class="icon">
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>

            <el-dropdown-menu slot="dropdown">
              <div>
                <el-dropdown-item command="a"> 返回首页 </el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div> 
        <div class="btncenter" data-permissions="view:ssg:data:center" v-has>
          <router-link
                :to="{ path: 'ssgSplat/dataCenter' }"
                 style="color: #6669e3;"
                >数据中心</router-link>
           
            </div>
      </div>
    </div>
     
      <el-main>
        <div class="sign adaptation">
          <div class="tab_nav">
            <div class="tab_search">
              <div class="tabs">
                <span class="checked">
                  项目列表
                  <i>{{ total }}</i
                  >个
                </span>
              </div>
            </div>
            <div class="btns" data-permissions="func:ssgaddproject" v-has>
              <router-link
                :to="{ path: 'ssgSplat/addItem' }"
                tag="button"
                class="btn subbtn"
                >添加项目</router-link
              >
            </div>
          </div>
          <div class="filter">
            <div class="content">
              <div label="项目名称" style="margin-bottom: 0; margin: 12px 20px">
                <span class="size">项目名称</span>
                <el-input
                  @keyup.enter.native="searchEnterFun"
                  placeholder="请输入"
                  v-model.trim="form.name"
                  style="width: 219px; margin-left: 10px"
                ></el-input>
              </div>
              <div label="项目经理" style="margin-bottom: 0; margin: 12px 17px">
                <span class="size">项目经理</span>
                <el-input
                  placeholder="请输入"
                  @keyup.enter.native="searchEnterFun"
                  v-model.trim="form.userName"
                  style="width: 219px; margin-left: 10px"
                ></el-input>
              </div>
              <div label="开启状态" style="margin-bottom: 0; margin: 12px 7px">
                <span class="size">开启状态</span>
                <el-select
                  style="width: 219px;margin-left: 7px"
                  v-model="form.status"
                  placeholder="请选择"
                >
                  <el-option label="启用中" :value="1"></el-option>
                  <el-option label="停用中" :value="0"></el-option>
                </el-select>
              </div>
              <div label="创建时间" style="margin-bottom: 0; margin: 12px 17px">
                <span class="size">创建时间</span>
                 <el-date-picker
                  v-model="form.createTime"
                  type="datetimerange"
                  range-separator="——"
                  start-placeholder="请选择"
                  end-placeholder="请选择"
                  style="width: 219px;margin-left:10px"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                >
                </el-date-picker>
              </div>
              <div style="margin-bottom: 0; margin: 12px 17px">
                <button type="button" class="btn subbtn" @click="onsubmit">
                  查询
                </button>
                <button style="margin-left: 8px" class="btn" @click="onreset">
                  清空
                </button>
              </div>
            </div>
          </div>
          <div class="table">
            <div class="tab" v-for="(v, k) in list" :key="k">
              <div
                v-if="btnPermissionsStr.includes('func:ssgshowproject')"
                class="name"
              >
                <p>
                  <span style="cursor: pointer" @click="junpSsg(v.id)">
                    {{ v.projectName }}
                  </span>
                </p>
              </div>
              <div v-else class="name">
                <p>
                  <span style="color: #9393a2">
                    {{ v.projectName }}
                  </span>
                </p>
              </div>
              <div class="tab_content">
                <!-- <div class="three">
                  <p>项目id</p>
                  <p style="margin-top: 10px">{{ v.id }}</p>
                </div> -->
                <!-- <div class="industry">
                  <p>行业类型</p>
                  <el-tooltip  placement="bottom" effect="light">
                    <template #content>
                      {{ v.industryName }}
                    </template>
                    <p style="margin-top: 10px;cursor: pointer;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{ v.industryName }}</p>
                  </el-tooltip>
                </div> -->
                <div class="three">
                  <p>项目经理</p>
                  <p style="margin-top: 10px">{{ v.userName }}</p>
                </div>
                <div class="three">
                  <p>待入职</p>
                  <p style="margin-top: 10px">{{ v.waitEntry }}</p>
                </div>
                <div class="three">
                  <p>待签订</p>
                  <p style="margin-top: 10px">{{ v.waitSign }}</p>
                </div>
                <div class="three">
                  <p>在职人数</p>
                  <p style="margin-top: 10px">{{ v.onEntry }}</p>
                </div>
                <div class="three">
                  <p>即将到期</p>
                  <p style="margin-top: 10px">{{ v.soonToExpire }}</p>
                </div>
                <div class="three">
                  <p>离职申请</p>
                  <p style="margin-top: 10px">{{ v.applyLeave }}</p>
                </div>
                <!-- <div class="three">
                  <p>手机号码</p>
                  <p style="margin-top: 10px">{{ v.mobile }}</p>
                </div> -->
                <div class="industry">
                  <p>开启状态</p>
                  <p style="margin-top: 4px">
                    <button class="span_bgc" v-if="v.status == 0">
                      停用中
                    </button>
                    <button class="span_bgc4" v-if="v.status == 1">
                      启用中
                    </button>
                  </p>
                </div>
                <div class="status">
                  <p style="font-size: 12px; color: #9393a2; text-align: center">关联状态</p>
                  <p
                    style="margin-top: 10px"
                    v-if="
                      (v.relationDetail &&
                        v.relationDetail.ssp.relationNum !== 0) ||
                      (v.rpoNumResponse && v.rpoNumResponse.relationNum !== 0)
                    "
                  >
                    <span
                      v-if="
                        v.rpoNumResponse && v.rpoNumResponse.relationNum !== 0
                      "
                    >
                      RPO<span style="color: #ff6752">{{
                        v.rpoNumResponse.relationNum
                      }}</span
                      >个/
                    </span>
                    <span
                      v-if="
                        v.relationDetail &&
                        v.relationDetail.ssp.relationNum !== 0
                      "
                    >
                      发薪<span style="color: #ff6752">
                        {{ v.relationDetail.ssp.relationNum }}</span
                      >个
                    </span>
                  </p>
                  <p
                    style="margin-top: 10px"
                    v-if="
                      v.relationDetail &&
                      v.relationDetail.ssp.relationNum == 0 &&
                      v.rpoNumResponse &&
                      v.rpoNumResponse.relationNum == 0
                    "
                  >
                    未关联
                  </p>
                </div>
                <div class="createTime">
                  <p>创建时间</p>
                  <p style="margin-top:10px">{{v.createDate}}</p>
                </div>
              </div>
              <div class="line">
                <p style="font-size: 12px; color: #9393a2; text-align: center">
                  操作
                </p>
                <div class="opera" style="margin-top: 10px">
                  <div data-permissions="func:ssgeditproject" v-has>
                    <span @click="onemore(v.id, v.is_default, v.projectName)"
                      >编辑</span
                    >
                  </div>
                  <div data-permissions="func:ssgopenproject" v-has>
                    <div style="disply: inline">
                      <span v-if="v.status == 0" @click="ondetails(v.id, 1)"
                        >启用</span
                      >
                      <span v-if="v.status == 1" @click="ondetails(v.id, 0)"
                        >停用</span
                      >
                    </div>
                  </div>

                  <span
                    v-if="v.managerStatus == 1"
                    @click="onview(v.id, v.projectName)"
                    >权限设置</span
                  >
                  <div>
                    <el-badge
                      v-if="
                        (v.relationDetail &&
                          v.relationDetail.ssp.newRequestNum > 0) ||
                        (v.rpoNumResponse && v.rpoNumResponse.newRequestNum > 0)
                      "
                      :value="
                        v.relationDetail.ssp.newRequestNum +
                        v.rpoNumResponse.newRequestNum
                      "
                    >
                      <span @click="onviews(v.projectCode, v.id)"
                        >关联设置</span
                      >
                    </el-badge>
                    <span v-else @click="onviews(v.projectCode, v.id)"
                      >关联设置</span
                    >
                  </div>

                  <div>
                    <!-- <span
                    v-if="
                     (v.relationDetail &&
                      v.relationDetail.ssp.newRequestNum <= 0) || (v.rpoNumResponse && v.rpoNumResponse.newRequestNum <= 0)
                    "
                    @click="onviews(v.projectCode, v.id)"
                    >关联设置</span
                  > -->
                  </div>
                </div>
              </div>
            </div>
            <div class="bgnull" v-if="list.length == 0 ">
              <div class="bg"></div>
              <div class="span">暂无数据</div>
            </div>
          </div>
          <page
            v-show="list.length > 0  "
            :page="pageNo"
            :pagesize.sync="pageSize"
            :total="total"
            ref="page"
            @currentChange="cur"
            @enter="cur"
          ></page>
        </div>
      </el-main>
    </div>
    <div class="authority" v-else>
      <div class="content">
        <p>您没有权限查看页面</p>
        <p>如需开通请联系系统管理员</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {},
  data() {
    return {
      edit: false,
      btnPermissionsStr: {},
      radio: 1,
      yesORno: false,
      list: [],
      tasknumber: 0,
      taskList: [{}],
      badgeHidden: true,
      maskshow: false,
      masktype: "",
      pushEmployTotal: 0,
      noconnect: 0,
      type: 2,
      noticeStatus: 1,
      pageNo: 1,
      pageSize: 10,
      id: "",
      total: 0,
      form: {
        name: "",
        userName: "",
        status: "",
        createTime:[],
      },
    };
  },
  watch: {
    pageNo: function (val, oldVal) {
      this.$refs.page.page = val;
    },
    "form.createTime"(newVal) {
      if (newVal == null) {
        this.form.createTime = [];
      }
    },
  },
  created() {
    this.load();

    this.yesORno = this.$route.params.yesORno;
  },
  methods: {
    load() {
      //  let btnPermissionsStr = sessionStorage.getItem("btnPermissions");
      //  if(!btnPermissionsStr) {
      let codes = "";
      this.$employAxios.get("/permission/getCodes").then((res) => {
        for (var i = 0; i < res.data.data.length; i++) {
          let vvv = "";
          codes += res.data.data[i] + ",";
          var str = codes.substring(0, codes.length - 1);
        }
        codes = str;
        sessionStorage.clear();
        sessionStorage.setItem("btnPermissions", codes);
        this.btnPermissionsStr = sessionStorage.getItem("btnPermissions");
        if (this.btnPermissionsStr.includes("view:ssgprojectlist")) {
          this.loadData();
        }
        this.edit = true;
      });
      //    }
    },
    searchEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
     
      if (keyCode == 13) {
        this.onsubmit();
      }
    },
    back() {
      this.$router.push({ path: "/main" });
    },
    junpSsg(id) {
      this.$axios
        .post("project/valid?projectId=" + id)
        .then((res) => {
          if (res.data.status == 1) {
            if (res.data.data == true) {
              window.location.href = this.$axios.defaults.baseURL3 + "#/home";
              var _this = this;
              _this.$emit("junbssgtmo", true);
            } else {
              this.$message.error("您没有该模块的查看权限");
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(() => {});
    },
    onreset() {
      this.form.name = "";
      this.form.status = "";
      this.form.userName = "";
      this.form.createTime=[]
    },
    addCommand(command) {
      if (command == "a") {
        this.$router.push({ path: "/main" });
      }
    },
    onsubmit() {
      this.pageNo = 1;
      this.loadData();
    },
    loadData() {
      const params = {
        name: this.form.name,
        userName: this.form.userName,
        status: this.form.status,
        createStartTime:this.form.createTime[0],
        createEndTime:this.form.createTime[1],
        pageNum: this.pageNo,
        pageSize: this.pageSize,
      };
      return this.$axios
        .get("/project/list", {
          params,
        })
        .then((res) => {
          if(res.data.data.list == null){
            this.list = []
          }else {
            this.list = res.data.data.list;

          }
          this.total = res.data.data.total;
          //   if( this.pageNo!==1 && this.list.length==0){
          //     this.pageNo = this.pageNo-1
          //     this.loadData()
          //   }
          // this.noticeStatus = res.data.data.noticeStatus -1;
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    ontab(v) {
      this.type = v;
      this.loadData();
    },
    onview(id, projectName) {
      this.$router.push({
        path: "ssgSplat/accpermission",
        query: {
          id: id,
          projectName: projectName,
        },
      });
    },
    onviews(code, id) {
      if (this.btnPermissionsStr.includes("view:ssg:showsspproject")) {
        this.loadData();
      }
      this.$router.push({
        path: "ssgSplat/settings/employPlatform",
        query: {
          code: code,
          id: id,
        },
      });
    },
    //删除
    ondelete(id) {
      this.maskshow = true;
      this.id = id;
    },
    lookat() {
      const params = { id: this.id, isToday: this.radio };
      this.$axios
        .delete("group/deleteGroup", { params })
        .then((res) => {
          if (res.data.status == 1) {
            this.$message.success(res.data.message);
            this.maskshow = false;
            this.loadData();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(() => {});
    },

    ondetails(id, name) {
      this.$axios
        .put("/project/updateStatus/" + id + "/" + name)
        .then((res) => {
          if (res.data.status == 1) {
            this.$message.success(res.data.message);
            this.loadData();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(() => {});
    },
    onemore(id, isDefault, projectName) {
      this.$router.push({
        path: "ssgSplat/addItem",
        query: {
          id: id,
          isDefault: isDefault,
          edit: true,
          projectName: projectName,
        },
      });
    },

    cur(val) {
      this.pageNo = val;
      this.loadData();
    },
  },
};
</script>

<style src="../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../assets/css/common/operating.less" scoped lang="less"></style>
<style src="../../assets/css/common/table.less" scoped lang="less"></style>
<style src="../../assets/css/common/card.less" scoped lang="less"></style>
<style scoped lang="less">
.el-main {
  height: calc(100vh - 60px);
}
.headerBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 63px;
  background-color: #f2f5f8;
  padding: 0 50px;
  .btncenter {
    color: #6669e3;
    cursor: pointer;
  }
}
.header {

  display: flex;
  align-items: center;
  .logo {
    // margin-left: 50px;
  }
  .icon {
    margin: 10px auto;
    width: 20px;
    height: 20px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #d8dae1;
    margin-left: 20px;
    i {
      margin: 3px;
    }
  }
}
.top {
  padding: 30px 0 0 0;
  .notice {
    color: #303140;
    font-weight: bold;
    font-size: 20px;
  }
  .notices {
    color: #303140;
    font-weight: bold;
    span {
      color: #6669e3;
      margin-left: 10px;
    }
  }
}
.sign {
  max-width: 1920px;
  // min-height: 100%;
  padding: 0 30px;
  margin: 0 auto;
  box-sizing: border-box;
  min-width: 1260px;
  /*background-color: #fff;
    border: 1px solid #d9dbe2;
    border-radius: 6px 6px 0 0;*/
  .operating {
    width: 100%;
    min-height: 62px;
    line-height: 62px;
    box-sizing: border-box;

    .search {
      margin-right: 14px;
    }
  }

  .table {
    width: 100%;

    .tab {
      width: 100%;
      height: 98px;
      display: flex;
      align-items: center;
      border: 1px solid #d9dbe2;
      border-radius: 12px;
      margin-bottom: 15px;
      padding: 14px 0;
      box-sizing: border-box;

      .name {
        width: 20%;
        // height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 25px;
        font-size: 16px;
        color: #6669e3;
      }
      .tab_content {
        flex: 1;
        display: flex;
        border-left: 1px solid #f2f5f8;
      }
      
      .industry {
        width: 15%;
        // height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        font-size: 12px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        
        p:first-child {
          color:#5A5B6B;
        }

        p:last-child {
          color:#303140;
        }
      }
      .line {
        width: 185px;
        padding: 0 24px;
        // height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 16px;
        color: #6669e3;
        border-left: 1px solid #f2f5f8;
        margin-bottom: 7px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .status {
        width: 15%;
        // height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        font-size: 12px;
        color: #9393a2;
        p:last-child {
          color:#303140;
          display: flex;
          justify-content: center;
        }
      }
      .createTime {
        width: 20%;
        // height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        font-size: 12px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        
        p:first-child {
          color: #5A5B6B;
        }

        p:last-child {
          color: #303140;
        }
      }

      .three {
        width: 11.5%;
        // height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        font-size: 12px;

        p:first-child {
          color: #5A5B6B;
        }

        p:last-child {
          color: #303140;
        }
      }

      .axis {
        width: 40%;
        // height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }

    .bgnull {
      // width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .bg {
        width: 214px;
        height: 110px;
        background-image: url(../../assets/img/10wvB0eE.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 214px 110px;
        margin-top: 100px;
      }
    }
  }
}

.pbg {
  width: 75px;
  display: flex;
  justify-content: center;

  i {
    font-size: 54px;
    color: #3bc798;
  }
}

.part {
  font-size: 18px;
  margin-left: 10px;

  p {
    margin: 5px 0;

    .red {
      color: #ff6752;
    }

    .green {
      color: #3bc798;
    }
  }
}
.submess {
  .form {
    display: flex;
    /*justify-content: space-around;*/
    .img {
      background-image: url("../../assets/img/warning.png");
      background-repeat: no-repeat;
      width: 50px;
      height: 50px;
    }
    .linhin {
      margin-left: 30px;
      height: 100px;
      line-height: 30px;
      .p1 {
        font-size: 14px;
        color: #303140;
        font-weight: bold;
      }
      .p2 {
        color: #303140;
      }
      .rad {
        color: #303140;
        .no {
          display: block;
          margin-left: 90px;
        }
      }
    }
  }
}
.filter {
  // width: 100%;
  min-width: 1260px;
  max-width: 100%;
  min-height: 57px;
  background: rgba(242, 245, 248, 1);
  border-radius: 4px;
  margin-bottom: 30px;
  .content {
    display: flex;
    flex-wrap: wrap;
    div{
      display:flex;
    }
  }
  .size {
    font-size: 12px;
    font-weight: 400;
    color:#545566;
    margin-top: 7px;
    // margin-left: 10px;
    // margin-right: 10px;
  }
  /deep/.el-input__icon .el-range__close-icon .el-icon-circle-close{
    position: absolute;
    right: 0;
  }
}
.opera {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #6669e3;
  span {
    margin: 0 5px;
    color: #6669e3;

    cursor: pointer;
  }
}
.span_bgc {
  border: none;
  padding: 5px 5px;
  background: rgba(254, 240, 240, 1);
  border-radius: 4px;
  border: 1px solid rgba(252, 210, 210, 1);
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
  width: 50px;
  color: rgba(245, 116, 116, 1);
  text-align: center;
  margin-top: 3px;
}

.span_bgc4 {
  border: none;
  padding: 5px 5px;
  background: rgba(234, 255, 248, 1);
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
  color: rgba(59, 199, 152, 1);
  border-radius: 4px;
  width: 50px;
  border: 1px solid rgba(183, 225, 211, 1);
  text-align: center;
  margin-top: 3px;
}
.authority {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  margin: 100px auto;

  .content {
    text-align: center;
    margin: 50px auto;
    font-size: 24px;
    font-weight: bold;
    color: #303140;
  }
}
</style>
